export default "__VITE_ASSET__DHWdwWw3__"